import * as actionTypes from '../actions/actionTypes';

const intiData = {
    data: {},
    statuses: {
        basicDetails: {
            status: "incomplete"
        },
        poolingStructure: {
            status: "incomplete",
            child :{
                basicDetailsAndAccount: {
                    status: "incomplete"
                },
                AdvantageAllocationSetting : {
                    status: "incomplete"
                }
            }
        },
        otherSetting: {
            status: "optional"
        },
        intersetOptimisation: {
            status: "optional"
        }
    }
};

export default function currentProductNotionalPooling(state = intiData , action) {
    switch(action.type){
        case actionTypes.SAVE_DATA_NOTIONAL_POOLING:
        let newState = {...state};
        newState.data = action.data;
        return newState;
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_STATUSES: {
            let newState = {...state};
            newState.statuses = action.statuses;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_PARTY_CURRENCY: {
            let newState = {...state};
            newState.currency = action.currency;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_BD_ACCOUNTS: {
            let newState = {...state};
            newState.accounts = action.accounts;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON: {
            let newState = {...state};
            newState.pageJson = action.par;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_1: {
            let newState = {...state};
            newState.pageJson1 = action.par;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_POOL_ID: {
            let newState = {...state};
            newState.poolIdAfterSaveRefresh = action.poolId;
            return newState;
        }
        case actionTypes.RESET_CURRENT_NOTIONAL_POOLING_POOL_ID: {
            let newState = {...state};
            newState.poolIdAfterSaveRefresh = undefined;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_2: {
            let newState = {...state};
            newState.pageJson2 = action.par;
            return newState;
        }

        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_PAGE_JSON_ACCODRIAN: {
            let newState = {...state};
            newState.pageJsonAccordian = action.par;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_INTEREST_OPTIMIZATION_DATA: {
            let newState = {...state};
            newState.dataIOFormJson = action.dataIO;
            return newState;
        }
        case actionTypes.SET_CURRENT_NOTIONAL_POOLING_INTEREST_PERIOD_SETTLEMENT_DATE: {
            let newState = {...state};
            newState.interestPeriodSettlementDate = action.date;
            return newState;
        }
        case actionTypes.SET_STATND_ALONE_ACCOUNTS: {
            let newState = {...state}

            let update = {
                ...newState,
                accounts:  action.account
            }
            return update;
        }
        case actionTypes.UPDATE_ACCOUNT_INFO: {
            let newState = {...state}
            let update = newState.accounts.map(item => {
                if(item.id === action.id){
                    item = action.data
                }
                return item
            })
            let updateData = {
                ...newState,
                accounts: update
            }
            return updateData;
        }
        case actionTypes.SET_NEW_POOL_ACTIVE_TAB_INDEX: {
          let newState = {...state};
          newState.activePoolTabIndex = action.index;
          return newState;
        }
        case actionTypes.RESET_NEW_POOL_ACTIVE_TAB_INDEX: {
          let newState = {...state};
          newState.activePoolTabIndex = 0;
          return newState;
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/reducer/currentProductNotionalPooling.js